<template>
	<v-layout>
		<v-flex xs11 sm11 md6>
			<p class="add-event-step-header mb-0">What type of wrkprty?</p>
			<v-radio-group v-model="typeSelection" :mandatory="false" class="mt-0">
				<div v-for="type in types" class="mb-4" :key="type.value">
					<v-radio
						:value="type.value"
						:disabled="getHost.allowed_event_types.indexOf(type.value) === -1"
						class="mt-2 mb-0 add-event-radio-selection disabled-radio"
					></v-radio>
					<div :class="['add-event-radio-title', {'disabled-radio-description': getHost.allowed_event_types.indexOf(type.value) === -1}]">
						{{ type.title }}
					</div>
					<div :class="['add-event-radio-subtitle', {'disabled-radio-description-lighter': getHost.allowed_event_types.indexOf(type.value) === -1}]">
						{{ type.subtitle }}
					</div>
					<div :class="['add-event-radio-description', {'disabled-radio-description': getHost.allowed_event_types.indexOf(type.value) === -1}]">
						{{ type.description }}
					</div>
				</div>
			</v-radio-group>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-title">About Event &amp; Experience types…</p>
					<p class="add-event-tip-content">We recommend that new hosts begin with the classic WRKPRTY coworking event before hosting other types of events. It’s the best way get started and get a feel for hosting.</p>
					<p class="add-event-tip-content">More experienced hosts are encouraged to try out our other formats - a good way to connect your local community in new and interesting ways during off hours.</p>
					<p class="add-event-tip-content">Interested in hosting something other than a WRKPRTY or WRKSHOP?</p>
					<p class="add-event-tip-content">Please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> to let us know, so we can add this permission for you!</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">About Event &amp; Experience types…</p>
					<p class="add-event-tip-content">We recommend that new hosts begin with the classic WRKPRTY coworking event before hosting other types of events. It’s the best way get started and get a feel for hosting.</p>
					<p class="add-event-tip-content">More experienced hosts are encouraged to try out our other formats - a good way to connect your local community in new and interesting ways during off hours.</p>
					<p class="add-event-tip-content">Interested in hosting something other than a WRKPRTY or WRKSHOP?</p>
					<p class="add-event-tip-content">Please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> to let us know, so we can add this permission for you!</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deepCopy } from '~/store/util/util'
export default {
	data() {
		return {
			types: [
				{
					title: 'WRKPRTY',
					value: 'wrkprty',
					subtitle: 'Coworking Event | Structured for ease & efficiency',
					description:
						"The original 'pop-up' coworking event is the perfect way to more productivity and connection anywhere."
				},
				{
					title: 'WRKSHOP',
					value: 'wrkshop',
					subtitle: 'Workshops | Classes | Trainings | Seminars',
					description:
						'People come to this type of event to be led through a structured program and learn, grow, & connect.'
				},
				{
					title: 'MXR',
					value: 'mxr',
					subtitle: 'Networking Events | Mixers | Social Meetings',
					description:
						'MXRs are events where the primary focus is on meeting others for networking and social interaction.'
				},
				{
					title: 'WRKPRTY PRSNTS',
					value: 'prsnts',
					subtitle: 'Panel Discussions | Fireside Chats | Presentations',
					description:
						'PRSNTS is an event format akin to TEDx with 2-4 speakers sharing valuable industry knowledge.'
				},
				{
					title: 'MSTRMND',
					value: 'mstrmnd',
					subtitle: 'Mastermind Group | Mentorship & Support',
					description:
						'A MSTRMND is an ongoing (or multi-week) meeting of a small group that support and mentor each other.'
				},
				{
					title: 'THNKTNK',
					value: 'thnktnk',
					subtitle: 'Thinktank | Focus Group | Brainstorming',
					description:
						'Bring people together to help solve real problems and generate constructive feedback and solutions.'
				},
				{
					title: 'HCKTHN',
					value: 'hckthn',
					subtitle: 'Hackathon | Collaboration Toward Shared Goal',
					description:
						'An event where we join together to collaborate and create something amazing in set period of time.'
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.typeSelection !== null) {
			this.setAddEventValidStep(from.path)
			this.removeAddEventInvalidStep(from.path)
		} else {
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setModalOpen',
			'setAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'removeAddEventValidStep',
			'setAddEventProp'
		])
	},
	computed: {
		...mapGetters(['getAddEventProp', 'getHost']),
		typeSelection: {
			get() {
				return this.getAddEventProp('wrkprtyType')
			},
			set(val) {
				this.setAddEventProp({ prop: 'wrkprtyType', value: val })
				this.setAddEventProp({ prop: 'title', value: val.toUpperCase() })

				let validSteps = deepCopy(this.getAddEventProp('validSteps'))
				for (var i = 0; i < validSteps.length; i++) {
					if (
						validSteps[i] !== '/host/add/event' &&
						validSteps[i] !== '/host/add/event/' &&
						validSteps[i] !== '/host/add/event/location' &&
						validSteps[i] !== '/host/add/event/location/' &&
						validSteps[i] !== '/host/add/event/type' &&
						validSteps[i] !== '/host/add/event/type/'
					) {
						this.setAddEventInvalidStep(validSteps[i])
						this.removeAddEventValidStep(validSteps[i])
					}
				}
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style scoped lang="scss">
.input-group--disabled {
	pointer-events: auto;
	cursor: no-drop !important;
	div {
		cursor: no-drop;
	}
}

.add-event-radio-selection {
	height: 0;
	label {
		display: none !important;
	}
}
</style>
